import { AbstractControl, ValidationErrors } from "@angular/forms";

const EMAIL_REGEXP = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;

export function emailValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (value == null || value.length === 0) {
        return null;
    }
    return EMAIL_REGEXP.test(control.value) ? null : { email: true };
}
